import { render } from "./EspecificacionesView.vue?vue&type=template&id=46acb985"
import script from "./EspecificacionesView.vue?vue&type=script&lang=js"
export * from "./EspecificacionesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__